/**
 * Máscaras de entrada, num lugar só (`FRM-10`).
 *
 * Estavam escritas literalmente nos templates: CPF em quatro lugares, telefone em cinco,
 * mais data e CEP. Literal repetido é literal que diverge — basta alguém escrever
 * `(00) 0000-0000` num campo para o sistema passar a aceitar telefone de oito dígitos em
 * uma tela e de nove nas outras, sem ninguém notar.
 *
 * O formato é o do `ngx-mask`: `0` é dígito.
 */
export const MASCARAS = {
  cpf: '000.000.000-00',
  /** Celular com nono dígito. */
  telefone: '(00) 00000-0000',
  /** Data por extenso na tela; a API recebe `yyyy-MM-dd` (`FRM-08`). */
  data: '00/00/0000',
  cep: '00.000-000',
} as const;
